// Gatsby requirements
import React, { useEffect } from "react"

// Styles
import * as CSS from './DarkModeToggle.module.scss'


const DarkModeToggle = () => {

    // Logic for dark mode
    function darkModeToggle() {
        var checkbox = document.getElementById("darkmode-switch");

        if (checkbox.checked === true){
            document.documentElement.setAttribute("color-mode", "dark")
            localStorage.setItem("darkmode-switch", checkbox.checked);
        } else {
            document.documentElement.removeAttribute("color-mode", "dark")
            localStorage.removeItem("darkmode-switch", checkbox.checked);
        }
    }

    useEffect(() => {
        // Saves dark mode
        var checked = JSON.parse(localStorage.getItem("darkmode-switch"));
        document.getElementById("darkmode-switch").checked = checked;

        // Calls for dark mode
        var checkbox = document.getElementById("darkmode-switch");
        localStorage.setItem("darkmode-switch", checkbox.checked);
        if (checkbox.checked === true){
            document.documentElement.setAttribute("color-mode", "dark")
        }
    });

    return (
        <div className={CSS.darkmodeStyle}>
            <input
                aria-label="toggle between dark and light mode"
                id="darkmode-switch"
                type="checkbox"
                onClick={darkModeToggle}
            />
        </div>
    )
}

export default DarkModeToggle